module.exports = __webpack_public_path__ + "assets/download.svg";